import app from '../app';
import Page, { IPageAttrs } from '../../common/components/Page';
import NotificationList from '../components/NotificationList';
import type Mithril from 'mithril';
import extractText from '../../common/utils/extractText';
import NotificationListState from '../states/NotificationListState';

/**
 * The `LikesPage` component shows the notifications list. It is only
 * used on mobile devices where the notifications dropdown is within the drawer.
 */
export default class CommentsPage<CustomAttrs extends IPageAttrs = IPageAttrs> extends Page<CustomAttrs> {
  oninit(vnode: Mithril.Vnode<CustomAttrs, this>) {
    super.oninit(vnode);
    app.history.push('notifications', extractText(app.translator.trans('dl-person.forum.comment')));
   
   app.notifications = new NotificationListState({
      filter: { type: ['newPost','userMentioned']},
      // sort: 'newest',
    });

    app.notifications.load();
    // app.notifications.refreshParams(param);
     
    this.bodyClass = 'App--notifications';
  }

  view() {
    return (
      <div className="NotificationsPage">
        <NotificationList title={app.translator.trans('dl-person.forum.comment')} state={app.notifications} type={1}></NotificationList>
      </div>
    );
  }
}
